import { useTranslation } from "react-i18next";
import { Contract } from "@/types";
import { useAuth } from "@/contexts/AuthContext";
import { getPaymentForCompany } from "@/utils/Contracts";

/**
 * The contract price from the current company's own side, for "You pay 7 000 NOK per ton": the label's translation
 * key, the always-positive price, and the currency and unit to put after it.
 */
export function usePaymentForCompany(contract: Contract) {
  const { t, i18n } = useTranslation();
  const { currentCompany } = useAuth();

  const { direction, price } = getPaymentForCompany(contract, currentCompany);
  const { currencyType, priceUnit } = contract.contractProduct;
  const perUnitKey = `enumerables:perPriceUnit.${priceUnit.unit.toLowerCase()}`;

  return {
    // In enumerables, so the extract keeps the keys even though they're built here.
    labelKey: `enumerables:paymentDirection.${direction}`,
    price,
    // A unit without a translation shows its own name instead of the key.
    suffix: `${currencyType} ${i18n.exists(perUnitKey) ? t(perUnitKey) : `per ${priceUnit.unit}`}`,
  };
}
